import type { StudyResponse } from '@/api/generated/types.gen';

/**
 * A study's design-point counts, as every study progress bar and fraction
 * reads them (ENG-2920).
 *
 * `finished` is any terminal outcome — the backend's `failed_points` already
 * counts cancelled points — so a study whose last point failed reads full
 * rather than stuck.
 */
export interface StudyPointProgress {
  total: number;
  finished: number;
  /** `finished` as a share of `total`, 0–100; 0 for a study with no points. */
  pct: number;
}

export function studyPointProgress(
  study: Pick<
    StudyResponse,
    'total_points' | 'completed_points' | 'failed_points'
  >,
): StudyPointProgress {
  const total = study.total_points;
  const finished = study.completed_points + study.failed_points;
  return {
    total,
    finished,
    pct: total > 0 ? Math.min(100, (finished / total) * 100) : 0,
  };
}
